export enum SendBackResultCode {
  Success = 0,
  Warning = -1,
  Error = -2,
  Deleted = -3,
  AccessDenied = -4,
  Duplicate = -5
}
